module.exports = __webpack_public_path__ + "img/cs2.be0df2f7.png";